import {CREATE_TRANSFER} from '../actions/index';

export default function (state = null, action) {
  switch (action.type) {
    case CREATE_TRANSFER:
      return action.payload.data;
    default:
      break;
  }
  return state;
}
